import { onBeforeUnmount, reactive, toRefs } from 'vue';
import { createLatestLoader } from '@/utils/requests';
export function useResource(initial = null) {
  const state = reactive({ data: initial, loading: false, error: null });
  const loader = createLatestLoader(patch => Object.assign(state, patch));
  onBeforeUnmount(loader.invalidate);
  return { ...toRefs(state), load: loader.load, invalidate: loader.invalidate };
}
